export const FILTERS = [
  { key: "all", label: "All", statuses: null },
  { key: "active", label: "Active", statuses: ["queued", "sending", "running"] },
  { key: "scheduled", label: "Scheduled", statuses: ["scheduled"] },
  { key: "paused", label: "Paused", statuses: ["paused"] },
  { key: "completed", label: "Completed", statuses: ["completed"] },
  { key: "cancelled", label: "Cancelled", statuses: ["cancelled"] },
  { key: "error", label: "Error", statuses: ["error"] },
];

export const filterItems = (items, key, search = "") => {
  const f = FILTERS.find((x) => x.key === key);
  let out = !f || !f.statuses ? items : items.filter((c) => f.statuses.includes(c.status));
  const q = search.trim().toLowerCase();
  if (q) out = out.filter((c) => [c.name, c.subject, c.audience_name].some((v) => (v || "").toLowerCase().includes(q)));
  return out;
};

export const StatusFilter = ({ items, value, onChange, accent = "indigo" }) => {
  const activeCls = accent === "emerald"
    ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/40"
    : "bg-indigo-500/15 text-indigo-300 border-indigo-500/40";
  return (
    <div className="flex flex-wrap gap-2" data-testid="campaign-status-filter">
      {FILTERS.map((f) => {
        const count = f.statuses ? items.filter((c) => f.statuses.includes(c.status)).length : items.length;
        if (count === 0 && f.key !== "all" && value !== f.key) return null;
        return (
          <button
            key={f.key}
            data-testid={`status-filter-${f.key}`}
            onClick={() => onChange(f.key)}
            className={`px-3 py-1 rounded-full text-xs font-mono border transition-colors ${
              value === f.key ? activeCls : "border-slate-800 text-slate-400 hover:border-slate-600 hover:text-slate-200"
            }`}
          >
            {f.label} <span className="opacity-60">{count}</span>
          </button>
        );
      })}
    </div>
  );
};
